import { render, staticRenderFns } from "./ModalEdocs.vue?vue&type=template&id=c0fe2c94"
import script from "./ModalEdocs.vue?vue&type=script&lang=js"
export * from "./ModalEdocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports